/** Credits: what this is, what it remakes, and how it was made. */

import './options.css';
import type { Ctx, Screen } from './context';
import { box, button, el } from './dom';
import { frame } from './widgets/frame';

const SECTIONS: ReadonlyArray<[head: string, lines: string[]]> = [
  [
    'PROJECT NIGHTDROP',
    [
      'A remake, from the ground up, of a 1987 game about one ranger, three supply pods and a long walk north.',
      'The 1987 game\'s name belongs to its rights holder. Project NIGHTDROP is an original work inspired by it:'
        + ' its own name, its own code, art, music and text.',
    ],
  ],
  [
    'CREATED BY',
    ['Graham Corrigan.', 'Design and direction, and the music.'],
  ],
  [
    'WITH RESPECT TO',
    ['The designers and programmers of the 1987 original, who put a roguelike inside a war game before the word.'],
  ],
  [
    'HOW IT IS MADE',
    [
      'No image or model files. Every shape is code, every colour comes from a palette, and every sound effect'
        + ' is synthesised. TypeScript, three.js, Vite and Vitest.',
      'The score is recorded. Where a track is missing, a synthesised one plays in its place.',
      'The opposing force is fictional: no real nation, language or insignia.',
    ],
  ],
  ['THE RULE', ['A ranger who dies on a mission is gone for good. Their names are on the Memorial Wall.']],
];

export function creditsScreen(ctx: Ctx): Screen {
  const f = frame('credits', 'CREDITS');
  const text = el('div', 'menu-credits menu-prose');
  for (const [head, lines] of SECTIONS) {
    text.append(el('div', 'menu-credits-head', head));
    for (const line of lines) text.append(el('div', '', line));
  }
  const back = button('BACK', () => ctx.nav.title());
  f.body.append(box('menu-col menu-grow menu-scroll', text), box('menu-col menu-options-side', back));
  return { el: f.el, back: () => ctx.nav.title(), initialFocus: () => back };
}
